// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d60c978b","30":"246bf060","67":"776895be","95":"4aea042f","119":"7d8ce92b","450":"2756e718","594":"8afba833","979":"e74ab251"}[chunkId] + ".chunk.js";
};